import { Button } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import * as S from './ArchiveFooter.styled.js'
import zLayers from 'utils/styling/zLayers'
import { useTranslation } from 'react-i18next'

export const ArchiveFooter = ({
  archive,
  clearSelectedRows,
  selectedRows,
  show,
  showingArchived,
}) => {
  const { t } = useTranslation()
  return (
    <S.Footer
      full
      left="0"
      zindex={zLayers.contentBase}
      height="70px"
      align="center"
      padding="0 42px"
      position="fixed"
      background="white"
      justify="space-between"
      bottom={show ? '0' : '-70px'}
      transition="0.25s"
      borderTop="1px solid"
      borderColor="gray4"
      show={show}
    >
      <Text>
        {t('dashboard.archiveFooter.selected', {
          count: selectedRows.length,
        })}
      </Text>
      <Flex row justify="flex-end" align="center">
        <Button margin="0 16px 0 0" onClick={() => clearSelectedRows()}>
          {t('dashboard.archiveFooter.cancel')}
        </Button>
        <Button primary onClick={() => archive(true)}>
          {showingArchived
            ? t('dashboard.archiveFooter.unarchive')
            : t('dashboard.archiveFooter.archive')}
        </Button>
      </Flex>
    </S.Footer>
  )
}

export default ArchiveFooter
